import type { QueryDSL, QueryResult, DatasetType } from '../types/QueryTypes';
import { applyFilters } from './FilterEngine';
import { applySort } from './SortEngine';
import { applyGroupBy } from './AggregateEngine';
function dedupById(rows: Record<string, unknown>[]): Record<string, unknown>[] {
  const seen = new Set<string>();
  return rows.filter(r => {
    const id = String(r.id ?? '');
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}
export function executeQuery(query: QueryDSL, requestData: Record<string, unknown>[], touchpointData: Record<string, unknown>[], searchFn?: (query: string, dataset: DatasetType) => Set<string>): QueryResult {
  const startTime = performance.now();
  const runSingleQuery = (data: Record<string, unknown>[], dataset: DatasetType): Record<string, unknown>[] => {
    console.log(`[NLQ] exec: dataset=${dataset}, inputRows=${data.length}`);
    let rows = data;
    if (query.dedup) {
      rows = dedupById(rows);
      console.log(`[NLQ] exec: after dedup=${rows.length}`);
    }
    if (query.search && searchFn) {
      const matchingIds = searchFn(query.search, dataset);
      rows = rows.filter(r => matchingIds.has(String(r.id)));
      console.log(`[NLQ] exec: after search=${rows.length}`);
    }
    if (query.filters && query.filters.length > 0) {
      rows = applyFilters(rows, query.filters);
      console.log(`[NLQ] exec: after filters=${rows.length}`);
    }
    if (query.groupBy) {
      rows = applyGroupBy(rows, query.groupBy, query.aggregate);
      console.log(`[NLQ] exec: after groupBy=${rows.length}`);
    } else if (query.sort) {
      rows = applySort(rows, query.sort);
      console.log(`[NLQ] exec: after sort=${rows.length}`);
    }
    if (query.limit) {
      rows = rows.slice(0, query.limit);
      console.log(`[NLQ] exec: after limit=${rows.length}`);
    }
    console.log(`[NLQ] exec: final rows=${rows.length}`);
    return rows;
  };
  let rows: Record<string, unknown>[];
  let dataset: DatasetType;
  if (query.dataset === 'both') {
    const requestRows = runSingleQuery(requestData, 'request').map(r => ({
      ...r,
      _type: 'request'
    }));
    const touchpointRows = runSingleQuery(touchpointData, 'touchpoint').map(r => ({
      ...r,
      _type: 'touchpoint'
    }));
    rows = [...requestRows, ...touchpointRows];
    dataset = 'both';
  } else if (query.dataset === 'request') {
    rows = runSingleQuery(requestData, 'request');
    dataset = 'request';
  } else {
    rows = runSingleQuery(touchpointData, 'touchpoint');
    dataset = 'touchpoint';
  }
  const executionTime = performance.now() - startTime;
  return {
    rows,
    metadata: {
      totalRows: rows.length,
      executionTime,
      dataset,
      appliedFilters: query.filters ?? []
    }
  };
}